<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Trámites sin Cita</h1>
      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div id="formulario">
              <div class="row">
                <div class="col-3 col-md-1"><b>Tipo De Trámite:</b></div>
                <div class="col-9 col-md-3">
                  <C013TiposTramites v-on:valorParaElPadre="cambioTipoTramite"
                                     :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                     :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                     :idDelInput="'catalogoTiposTramites'"
                                     :parametros="parametros_TiposTramites"
                                     :valorDefinido="parametros_TiposTramites.ValorDefinido">
                  </C013TiposTramites>
                </div>
                <div class="col-3 col-md-1"><b>Hora:</b></div>
                <div class="col-9 col-md-3">
                  <select class="form-control" v-model="HoraBloque" id="catalogoHoras">
                    <option v-for="hora in horasBloquesAgenda" :value="hora">{{hora}}</option>
                  </select>

                </div>
              </div>
              <div class="row">
                <div class="col-3 col-md-1">Tipo de Documento:</div>
                <div class="col-9 col-md-3">
                  <C004TipoDocumento v-on:valorParaElPadre="cambioTipoDocumento"
                                     :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                     :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                     :idDelInput="'catalogoTiposDocumento'"
                                     :parametros="parametros_TipoDocumento"
                                     :valorDefinido="parametros_TipoDocumento.ValorDefinido">
                  </C004TipoDocumento>
                </div>
                <div class="col-3 col-md-1">Materia:</div>
                <div class="col-9 col-md-3">
                  <C002Materias v-on:valorParaElPadre="cambioMateria"
                                :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                :idDelInput="'catalogoMateria'"
                                :parametros="parametros_Materia"
                                :valorDefinido="parametros_Materia.ValorDefinido"
                                :key="parametros_Materia.AreaId">
                  </C002Materias>
                </div>
                <div class="col-3 col-md-1">Número de Expediente:</div>
                <div class="col-9 col-md-3">
                  <input type="text" class="form-control" :placeholder="placeholderNumExpediente" @keypress="validarNumero" @keyup="anadirDiagonal" :maxlength="largoNumExpediente" v-model="NumeroExpediente" v-bind:disabled="parametros_TipoDocumento.TipoDocumentoId == -1 || parametros_TipoDocumento.TipoDocumentoId == null" />
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-md-10"></div>
                <div class="col-12 col-md-2 col-sm-6">
                  <button class="form-control overwrapDeBotones truncate" v-bind:disabled="bloquearBotonAgregarExpediente" @click="AnadirExpediente">
                    <i class="fas fa-file-medical fa-lg" style="margin-right:5px;" />Añadir Expediente
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="tabla">
            <div class="row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover" id="tablaExpedientes">
                  <thead class="thead-dark">
                    <tr class="visible-element">
                      <th>#</th>
                      <th>Tipo de Documento</th>
                      <th>Número de Expediente</th>
                      <th>Materia</th>
                      <th>Eliminar</th>
                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr v-for="(Expediente,indice) in Expedientes">
                      <td>{{indice+1}}</td>
                      <td>{{Expediente.TipoDocumento}}</td>
                      <td>{{Expediente.NumeroExpediente}}</td>
                      <td>{{Expediente.Materia}}</td>
                      <td><i class="fas fa-trash fa-2x" @click="QuitarExpediente(indice)" /></td>
                    </tr>
                    <tr v-if="Expedientes.length == 0"><td colspan="4">No se han agregado expedientes.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-9"></div>
              <div class="col-3">
                <button class="form-control" v-bind:disabled="bloquearBotonGuardarTramite" @click="GuardarTramite">
                  <i class="fas fa-save fa-lg" style="margin-right:5px;" />Guardar Trámite
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'

  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        parametros_TiposTramites: {
          ValorDefinido: -1,
          TipoTramite: null,
          TipoTramiteId: null,
          TipoTramiteSeleccionadoId: null,
          ConInactivos: false,
          mostrarBoton: false,
          nombre: "",
          areaId: null
        },
        parametros_TipoDocumento: {
          ValorDefinido: -1,
          TipoDocumentoId: null,
          AreaId: 1,
          soloDocumentosPrincipales: true,
          TextoSeleccionado: ""
        },
        parametros_Materia: {
          ValorDefinido: -1,
          MateriaId: null,
          AreaId: null,
          TextoSeleccionado: ""
        },
        horasBloquesAgenda: [],
        NumeroExpediente: "",
        Expedientes: [],
        HoraBloque: null,
        Dia: null,
        largoNumExpediente: 9,
        placeholderNumExpediente: "####/####"
      }
    },
    components: {
      C013TiposTramites: catalogos.SICCIJ.C013TiposTramites,
      C004TipoDocumento: catalogos.PJ.C004TipoDocumento,
      C002Materias: catalogos.PJ.C002Materias
    },
    methods: {
      cambioTipoTramite(datos) {
        var datosEvento = datos[0];
        this.parametros_TiposTramites.TipoTramite = datos[1];
        this.parametros_TiposTramites.nombre = $("#catalogoTiposTramites option:selected").text();
        this.parametros_TiposTramites.TipoTramiteSeleccionadoId = parseInt(datosEvento.target.value);
        if (this.parametros_TiposTramites.TipoTramiteSeleccionadoId == 6) {
          $('#catalogoTiposDocumento').val(-1);
          this.parametros_TipoDocumento.TipoDocumentoId = -1;
          //this.parametros_TipoDocumento.TextoSeleccionado = "No Aplica"
          this.NumeroExpediente = "";
          $('#catalogoTiposDocumento').attr('disabled', 'disabled');
        } else {
          $('#catalogoTiposDocumento').removeAttr('disabled');
        }
      },
      cambioTipoDocumento(datos) { //Administra los cambios en el componente de Tipo Documento.
        catalogos
        //console.log(datos.target);
        this.parametros_TipoDocumento.TipoDocumentoId = parseInt(datos.target.value);
        this.parametros_TipoDocumento.TextoSeleccionado = datos.target.options[datos.target.selectedIndex].text;
        this.NumeroExpediente = "";
        this.largoNumExpediente = (this.parametros_TipoDocumento.TipoDocumentoId != 2 && this.parametros_TipoDocumento.TipoDocumentoId != 10) ? 9 : 11;
        this.placeholderNumExpediente = (this.parametros_TipoDocumento.TipoDocumentoId != 2 && this.parametros_TipoDocumento.TipoDocumentoId != 10) ? "####/####" : "####/####-#";
      },
      cambioMateria(datos) { //Administra los cambios en el componente de Materia.
        catalogos
        //console.log(datos.target);
        this.parametros_Materia.MateriaId = parseInt(datos.target.value);
        this.parametros_Materia.TextoSeleccionado = datos.target.options[datos.target.selectedIndex].text;
      },
      GetBloquesAgendaHoy: function () { //Obtiene un listado de los bloques de la agenda en el area para el dia en curso.
        var peticion = {
          "esPrueba": false
        };
        console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetBloquesAgendaHoy, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.horasBloquesAgenda = response.data.HorasBloquesAgenda;
            this.Dia = response.data.Dia;
            this.parametros_Materia.AreaId = response.data.AreaPJId;
            this.parametros_TiposTramites.areaId = response.data.AreaPJId;
            if (this.horasBloquesAgenda.length > 0) {
              this.HoraBloque = this.horasBloquesAgenda[0];
            }
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      GetAreaIdUsuario: function () { //Obtiene el id del juzgado al que pertenece el usuario.
        var peticion = {
          "esPrueba": false
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetAreaIdUsuario, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.parametros_TipoDocumento.AreaId = response.data.AreaId;
            this.parametros_Materia.AreaId = response.data.AreaId;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      validarNumero: function ($event) { //valida que el caracter ingresado en el input de expediente sea un número.
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
          $event.preventDefault();
        }
      },
      anadirDiagonal: function ($event) {
        if (this.NumeroExpediente.length == 4) {
          this.NumeroExpediente += "/"
        }
        else if ((this.parametros_TipoDocumento.TipoDocumentoId == 2 || this.parametros_TipoDocumento.TipoDocumentoId == 10) && this.NumeroExpediente.length == 9) {
          this.NumeroExpediente += "-"
        }


      },
      AnadirExpediente: function () { //añade los datos del expediente del formulario a la lista.
        $('#catalogoTiposTramites').attr('disabled', 'disabled');
        if (this.parametros_TiposTramites.TipoTramiteSeleccionadoId == 6) {
          this.Expedientes.push({
            TipoDocumento: "No Aplica",
            TipoDocumentoId: null,
            NumeroExpediente: "No Aplica",
            MateriaId: this.parametros_Materia.MateriaId,
            Materia: this.parametros_Materia.TextoSeleccionado
          })
        } else {
          this.Expedientes.push({
            TipoDocumento: this.parametros_TipoDocumento.TextoSeleccionado,
            TipoDocumentoId: this.parametros_TipoDocumento.TipoDocumentoId,
            NumeroExpediente: this.NumeroExpediente,
            MateriaId: this.parametros_Materia.MateriaId,
            Materia: this.parametros_Materia.TextoSeleccionado
          })
        }
        this.NumeroExpediente = "";
        $('#catalogoTiposDocumento').val(-1);
        $('#catalogoMateria  ').val(-1);
        this.parametros_TipoDocumento.TipoDocumentoId = -1;
        this.parametros_Materia.MateriaId = -1;

        //this.parametros_Materia.MateriaId = -1;
        //this.parametros_TipoDocumento.TipoDocumentoId = -1
      },
      ResetearFormulario: function () {
        $('#catalogoTiposDocumento').removeAttr('disabled');
        $('#catalogoTiposTramites').removeAttr('disabled');
        $('#catalogoTiposTramites').val(-1);
        $('#catalogoTiposDocumento').val(-1);
        $('#catalogoHoras').prop("selectedIndex", 0);
        this.parametros_Materia.MateriaId = -1;
        this.parametros_TipoDocumento.TipoDocumentoId = -1;
        this.parametros_TiposTramites.TipoTramiteSeleccionadoId = -1;
      },
      QuitarExpediente: function (indice) { //Elimina el expediente de la lista.
        this.Expedientes.splice(indice, 1);
        if (this.Expedientes.length == 0) {
          this.ResetearFormulario();
        }
      },
      GuardarTramite: function () {//Guarda en BD el trámite.
        var peticion = {
          "esPrueba": false,
          "Expedientes": this.Expedientes,
          "TipoTramiteId": this.parametros_TiposTramites.TipoTramiteSeleccionadoId,
          "Hora": this.HoraBloque,
          "Dia": this.Dia,
          "AreaId": this.parametros_TipoDocumento.AreaId

        };
        console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.AgregarTramiteSinCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.ResetearFormulario();
            this.Expedientes = [];
            comun.mensajeDeAlerta("Trámite registrado exitosamente.", null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }
    },
    computed: {
      bloquearBotonAgregarExpediente: function () { //Valida que todos los input del expediente estén llenos correctamente.
        return ((this.parametros_TipoDocumento.TipoDocumentoId == null || this.parametros_TipoDocumento.TipoDocumentoId == -1
          || this.NumeroExpediente == "" || this.NumeroExpediente.length != this.largoNumExpediente) && this.parametros_TiposTramites.TipoTramiteSeleccionadoId != 6)
          || this.parametros_Materia.MateriaId == null || this.parametros_Materia.MateriaId == -1

      },
      bloquearBotonGuardarTramite: function () {  //Valida que todos los input del trámite estén llenos correctamente.
        return this.parametros_TiposTramites.TipoTramiteSeleccionadoId == null || this.parametros_TiposTramites.TipoTramiteSeleccionadoId == -1 || this.HoraBloque == "" || this.HoraBloque == null || this.Expedientes.length == 0;
      }
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      this.GetBloquesAgendaHoy();
      this.GetAreaIdUsuario();
    }

  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  button {
    cursor: pointer;
  }

  .fas {
    cursor: pointer;
  }

  button.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/TramiteSinCita/TramiteSinCita.vue